module.exports = __webpack_public_path__ + "img/bgNoticeSalaryAdjustment.45db24e5.png";